function isBoolean (value) {
  return value === false || value === true
}

function isObject (obj) {
  return isArrayOrObject(obj) && !isArray(obj)
}

function isString (str) {
  return Object.prototype.toString.call(str) === '[object String]'
}

function isArray (value) {
  return Array.isArray(value)
}

function isArrayOrObject (value) {
  return value && typeof value === 'object'
}

function isNumber (nb) {
  return typeof (nb) === 'number'
}

function isInteger (v) {
  return isNumber(v) && (Math.floor(v) === v)
}

function isFloat (v) {
  return isNumber(v) && (Math.floor(v) !== v)
}

function isFunction (f) {
  return f && {}.toString.call(f) === '[object Function]'
}

function isRegExp (r) {
  return Object.prototype.toString.call(r) === '[object RegExp]'
}

class FunctionList {
  constructor (list) {
    this._list = list
  }

  append (l) {
    this._list.push(l)
  }
}

export default {
  isBoolean,
  isString,
  isArray,
  isArrayOrObject,
  isObject,
  isFloat,
  isNumber,
  isInteger,
  isFunction,
  isRegExp,
  FunctionList
}
